<template>
    <table class="approval-table">
      <tbody>
        <tr>
          <td rowspan="2" class="label-cell">결재</td>
          <td class="label-cell"> 담당</td>
          <td class="label-cell">주임</td>
          <td class="label-cell">대리</td>
          <td class="label-cell">팀장</td>
          <td class="label-cell">실장</td>
          <td class="label-cell">이사</td>
        </tr>
        <tr>
          <td></td>
          <td class="sign-box" v-for="i in 5" :key="i"></td>
        </tr>
      </tbody>
    </table>
  </template>
  <style scoped>
        .approval-table {
          min-height: 60px;
          overflow: visible;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 20px;
        }
        th, td {
          border: 1px solid #000;
          padding: 6px;
          text-align: center;
        }
        .sign-box {
          height: 40px;
        }
        .label-cell {
          background-color: #f3f3f3;
          font-weight: bold;
        }
        .data-cell {
          background-color: #fff;
        }
</style>
